/**
 * PDP sticky ATC (pdp-tlpc)
 * - Always visible from page load (persistent bottom CTA)
 * - Qty stepper UI
 * - Sync quantity into the product form (or add via AJAX with explicit qty)
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function moneyFromCents(cents) {
    if (cents == null || isNaN(cents)) return '';
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && theme.moneyFormat) {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      }
    } catch (e) {}
    return '₹' + Math.round(Number(cents) / 100).toLocaleString('en-IN');
  }

  function getVariants(sectionId) {
    var el = document.getElementById('PdpStickyAtcVariants-' + sectionId);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function findVariant(variants, id) {
    var key = String(id);
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && String(variants[i].id) === key) return variants[i];
    }
    return null;
  }

  function getProductForm(sectionId) {
    var scoped =
      document.querySelector('#ProductInfo-' + sectionId + ' product-form form') ||
      document.querySelector('#ProductInfo-' + sectionId + ' form[data-type="add-to-cart-form"]');
    if (scoped) return scoped;
    return document.querySelector('product-form form[data-type="add-to-cart-form"]');
  }

  function initStickyAtc(root) {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var sectionId = root.dataset.sectionId;
    var variants = getVariants(sectionId);
    var mainAtc = document.getElementById('ProductSubmitButton-' + sectionId);

    var stickyAtcBtn = root.querySelector('[data-sticky-atc]');
    var qtyInput = root.querySelector('[data-sticky-qty]');
    var qtyMinus = root.querySelector('[data-sticky-qty-minus]');
    var qtyPlus = root.querySelector('[data-sticky-qty-plus]');
    var titleEl = root.querySelector('[data-sticky-title]');
    var priceEl = root.querySelector('[data-sticky-price]');
    var compareEl = root.querySelector('[data-sticky-compare]');
    var thumbEl = root.querySelector('[data-sticky-thumb]');
    var atcLabelEl = root.querySelector('[data-sticky-atc-label]');

    var qtyMin = Math.max(1, parseInt(root.dataset.qtyMin, 10) || 1);
    var qtyStep = Math.max(1, parseInt(root.dataset.qtyStep, 10) || 1);
    var qtyMax = root.dataset.qtyMax ? parseInt(root.dataset.qtyMax, 10) : null;
    if (qtyMax != null && isNaN(qtyMax)) qtyMax = null;

    function showStickyBar() {
      root.hidden = false;
      root.removeAttribute('hidden');
      root.setAttribute('aria-hidden', 'false');
      root.classList.add('is-visible');
      document.documentElement.classList.add('pdp-sticky-atc-active');
    }

    function clampQty(raw) {
      var value = parseInt(raw, 10);
      if (isNaN(value)) value = qtyMin;
      if (value < qtyMin) value = qtyMin;
      if (qtyMax != null && value > qtyMax) value = qtyMax;
      // Align to step relative to min
      var offset = value - qtyMin;
      value = qtyMin + Math.round(offset / qtyStep) * qtyStep;
      if (value < qtyMin) value = qtyMin;
      if (qtyMax != null && value > qtyMax) value = qtyMax;
      return value;
    }

    function getQty() {
      return clampQty(qtyInput ? qtyInput.value : qtyMin);
    }

    function updateQtyControls(value) {
      var unavailable = root.dataset.available === 'false';
      if (qtyMinus) qtyMinus.disabled = unavailable || value <= qtyMin;
      if (qtyPlus) qtyPlus.disabled = unavailable || (qtyMax != null && value >= qtyMax);
      if (qtyInput) qtyInput.disabled = unavailable;
      if (stickyAtcBtn) stickyAtcBtn.disabled = unavailable;
    }

    function ensureFormQtyInput(form) {
      if (!form) return null;
      var input =
        document.getElementById('PdpStickyFormQuantity-' + sectionId) ||
        form.querySelector('input[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.id = 'PdpStickyFormQuantity-' + sectionId;
        form.appendChild(input);
      }
      return input;
    }

    function syncQtyToForm(value) {
      var form = getProductForm(sectionId);
      var formQty = ensureFormQtyInput(form);
      if (formQty) {
        formQty.value = String(value);
        formQty.setAttribute('value', String(value));
      }
      // Keep any visible quantity inputs in sync (if the block is re-enabled later)
      document.querySelectorAll('#ProductInfo-' + sectionId + ' input[name="quantity"]').forEach(function (el) {
        if (el === formQty) return;
        el.value = String(value);
        el.setAttribute('value', String(value));
      });
    }

    function setQty(next, options) {
      options = options || {};
      var value = clampQty(next);
      if (qtyInput) {
        qtyInput.value = String(value);
        qtyInput.setAttribute('value', String(value));
      }
      updateQtyControls(value);
      if (!options.skipFormSync) syncQtyToForm(value);
      return value;
    }

    function setAvailable(available, label) {
      root.dataset.available = available ? 'true' : 'false';
      if (atcLabelEl && label) atcLabelEl.textContent = label;
      updateQtyControls(getQty());
    }

    function updateFromVariant(variant) {
      if (!variant) return;

      if (priceEl) priceEl.textContent = moneyFromCents(variant.price);

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = moneyFromCents(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }

      if (titleEl) {
        var base = titleEl.getAttribute('data-product-title') || '';
        titleEl.textContent =
          variant.title && variant.title !== 'Default Title' ? base + ' · ' + variant.title : base;
      }

      if (thumbEl) {
        var src = null;
        if (variant.featured_image && variant.featured_image.src) src = variant.featured_image.src;
        else if (variant.featured_media && variant.featured_media.preview_image)
          src = variant.featured_media.preview_image.src;
        if (src) {
          try {
            var url = new URL(src, window.location.origin);
            url.searchParams.set('width', '120');
            thumbEl.src = url.toString();
          } catch (e) {
            thumbEl.src = src;
          }
        }
      }

      if (variant.quantity_rule) {
        if (variant.quantity_rule.min != null) {
          qtyMin = Math.max(1, parseInt(variant.quantity_rule.min, 10) || 1);
          root.dataset.qtyMin = String(qtyMin);
          if (qtyInput) qtyInput.min = String(qtyMin);
        }
        if (variant.quantity_rule.increment != null) {
          qtyStep = Math.max(1, parseInt(variant.quantity_rule.increment, 10) || 1);
          root.dataset.qtyStep = String(qtyStep);
          if (qtyInput) qtyInput.step = String(qtyStep);
        }
        if (variant.quantity_rule.max != null && variant.quantity_rule.max !== '') {
          qtyMax = parseInt(variant.quantity_rule.max, 10);
          if (isNaN(qtyMax)) qtyMax = null;
          if (qtyMax != null) {
            root.dataset.qtyMax = String(qtyMax);
            if (qtyInput) qtyInput.max = String(qtyMax);
          }
        } else {
          qtyMax = null;
          delete root.dataset.qtyMax;
          if (qtyInput) qtyInput.removeAttribute('max');
        }
      }

      var available = variant.available !== false;
      var label = available
        ? (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart'
        : (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      setAvailable(available, label);
      setQty(getQty());
    }

    function syncAvailabilityFromMain() {
      if (!mainAtc) return;
      var available = !mainAtc.hasAttribute('disabled');
      var span = mainAtc.querySelector(':scope > span');
      var label = span ? span.textContent.trim() : '';
      setAvailable(available, label || undefined);
    }

    function addToCartWithQty() {
      if (root.dataset.available === 'false') return;
      var qty = setQty(getQty());
      var form = getProductForm(sectionId);
      if (!form) return;

      ensureFormQtyInput(form);
      syncQtyToForm(qty);

      var submit =
        form.querySelector('#ProductSubmitButton-' + sectionId) ||
        mainAtc ||
        form.querySelector('[type="submit"][name="add"]');

      // Always prefer the main product-form submit so Shopify web pixel / CAPI
      // see the same cart-add path as the primary PDP Add to Cart button.
      if (submit && !submit.hasAttribute('disabled')) {
        if (submit.getAttribute('aria-disabled') === 'true') return;
        // requestSubmit triggers the form's submit listeners (product-form.js).
        // Element.click() on the button is unreliable in some browsers/contexts.
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submit);
        } else {
          submit.click();
        }
        return;
      }

      // Fallback only if the main submit is missing/unavailable: still use Shopify cart add API.
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/json' } };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(form);
      formData.set('quantity', String(qty));

      if (cart && typeof cart.getSectionsToRender === 'function') {
        try {
          formData.append(
            'sections',
            cart.getSectionsToRender().map(function (section) {
              return section.id;
            })
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        } catch (e) {}
      }
      config.body = formData;

      if (stickyAtcBtn) {
        stickyAtcBtn.setAttribute('aria-disabled', 'true');
        stickyAtcBtn.classList.add('loading');
      }

      var addUrl = (window.routes && routes.cart_add_url) || '/cart/add';
      fetch(addUrl, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            if (window.publish && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'pdp-sticky-atc',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            return;
          }
          if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'pdp-sticky-atc',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }
          if (cart && typeof cart.renderContents === 'function') cart.renderContents(response);
          else if (window.routes && routes.cart_url) window.location = routes.cart_url;
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          if (stickyAtcBtn) {
            stickyAtcBtn.classList.remove('loading');
            stickyAtcBtn.removeAttribute('aria-disabled');
          }
        });
    }

    // Always visible from the start — no scroll gate
    showStickyBar();

    // Qty controls
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setQty(getQty() - qtyStep);
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setQty(getQty() + qtyStep);
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        // Live-sanitize while typing without fighting the caret too hard
        var raw = parseInt(qtyInput.value, 10);
        if (!isNaN(raw)) syncQtyToForm(clampQty(raw));
      });
      qtyInput.addEventListener('change', function () {
        setQty(qtyInput.value);
      });
      qtyInput.addEventListener('blur', function () {
        setQty(qtyInput.value);
      });
      qtyInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          setQty(qtyInput.value);
          addToCartWithQty();
        }
      });
    }

    if (stickyAtcBtn) {
      stickyAtcBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        addToCartWithQty();
      });
    }

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || !event.data.variant) return;
        if (event.data.sectionId && event.data.sectionId !== sectionId) return;
        updateFromVariant(event.data.variant);
      });
    }

    // Only watch disabled — avoid childList/characterData loops that reset qty
    if (mainAtc && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        syncAvailabilityFromMain();
      });
      mo.observe(mainAtc, { attributes: true, attributeFilter: ['disabled'] });
    }

    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    if (productInfo) {
      productInfo.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.addEventListener('change', function () {
          var variant = findVariant(variants, input.value);
          if (variant) updateFromVariant(variant);
          else syncAvailabilityFromMain();
        });
      });
    }

    setQty(qtyMin);
    syncAvailabilityFromMain();
  }

  ready(function () {
    var root = document.getElementById('PdpStickyAtc');
    if (root) initStickyAtc(root);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target && event.target.querySelector
        ? event.target.querySelector('#PdpStickyAtc')
        : document.getElementById('PdpStickyAtc');
    if (root) {
      root.dataset.bound = 'false';
      initStickyAtc(root);
    }
  });
})();
